import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'

const Triangle = (props) => {
  return (
    <svg
      width='10'
      height='8'
      viewBox='0 0 10 8'
      {...props}
    >
      <path d='M8.72733 0.5L1.8609 0.5C1.06375 0.5 0.587048 1.38709 1.02697 2.05187L4.46019 7.23984C4.8556 7.83735 5.73264 7.83735 6.12805 7.23984L9.56127 2.05187C10.0012 1.38709 9.52449 0.5 8.72733 0.5Z' />
    </svg>
  )
}

const TriangleVertical = styled(
  ({ className }) => <Triangle className={className} />
)(({ theme, isActive }) => css`
  fill: ${isActive ? theme.blueElectric : theme.white};
  transform: rotate(${isActive ? '180deg' : 0});
`)

export default Triangle
export { TriangleVertical }
